import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Form, Question } from 'utils';

type ReturnType = Promise<AxiosResponse<Form>>;

const addQuestionToSection = (formId: string, sectionId: string, payload: Question): ReturnType => {
    return Request.post(`/data/forms/${formId}/sections/${sectionId}/questions`, payload);
};

export default addQuestionToSection;
